'use strict';

var Sugar = require('sugar-core');

require('./build/buildRelativeAliasesCall');

module.exports = Sugar.Date.isTomorrow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/isTomorrow.js
// module id = 248
// module chunks = 1